//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IconView from "./IconView.vue";

export default {
  name: "DonationsTableView",
  components: {
    IconView,
  },
  provide: {
    source: 'objCharacteristics'
  },
  props: {
    properties: {
      type: Array,
      default: new Array()
    },
    icon: {
      type: String,
      default: ''
    },
    textColor: {
      type: String,
      default: 'var(--black)'
    }
  },
}
